import * as React from 'react'
import { HeaderContext, Image } from '@ds/ui'
import { HeaderBar } from './HeaderBar'
import DocuSignLogo from './Common/HeaderDocuSignLogo'
import styles from './styles'
import OliveImages from '@olive/images'

export interface EmptyHeaderProps {
  dark?: boolean
  homeUrl: string // URL to load if logo is clicked
  appName?: string
  rebrand2024?: boolean
}

export const EmptyHeader = ({
  dark,
  homeUrl,
  appName,
  rebrand2024,
}: EmptyHeaderProps) => {
  const contextValue = React.useMemo(
    () => ({
      dark,
    }),
    [dark]
  )
  return (
    <HeaderContext.Provider value={contextValue}>
      <HeaderBar
        visible={true}
        startElement={
          <div css={{ marginInlineStart: 10 }}>
            <a
              css={styles.appDescriptionNonProductEmptyCSS}
              href={homeUrl}
              onClick={(event) => {
                event.preventDefault()
                window.location.href = homeUrl
              }}
            >
              {rebrand2024 ? (
                <div css={{ width: 124, paddingBlockStart: 6 }}>
                  <Image
                    src={
                      dark
                        ? OliveImages.dsLogoInverse
                        : OliveImages.dsLogoDefault
                    }
                    alt="Docusign"
                    data-qa="header-docusign-logo"
                  />
                </div>
              ) : (
                <DocuSignLogo dark={dark} appName={appName} />
              )}
            </a>
          </div>
        }
      />
    </HeaderContext.Provider>
  )
}
